import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import PickingCriteriaList01Actions, {
  PickingCriteriaList01Types
} from '../Stores/PickingCriteriaList01/Actions';

const getAppStore = state => state.app;

export function* pickingCriteriaList01FetchPickingCriteriaList01({
  currentPage,
  sorts,
  filters,
  pageSize
}) {
  try {
    yield put(
      PickingCriteriaList01Actions.pickingCriteriaList01FetchPickingCriteriaList01Loading(true)
    );

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `pickingCriteria/indexProcess/PICKING_CRITERIA_LIST_01/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        PickingCriteriaList01Actions.pickingCriteriaList01FetchPickingCriteriaList01Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      PickingCriteriaList01Actions.pickingCriteriaList01FetchPickingCriteriaList01Loading(false)
    );
  }
}

export function* pickingCriteriaList01GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/pickingCriteriaDetail/update/${hdrId}`));
}

export function* pickingCriteriaList01GoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/PICKING_CRITERIA/${hdrId}/PickingCriteria`));
}

export const saga = [
  takeLatest(
    PickingCriteriaList01Types.PICKING_CRITERIA_LIST01_GO_TO_AUDIT,
    pickingCriteriaList01GoToAudit
  ),
  takeLatest(
    PickingCriteriaList01Types.PICKING_CRITERIA_LIST01_FETCH_PICKING_CRITERIA_LIST01,
    pickingCriteriaList01FetchPickingCriteriaList01
  )
];
